import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Audience } from './components/Audience';
import { Product } from './components/Product';
import { Comparison } from './components/Comparison';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { StickyCTA } from './components/StickyCTA';
import { SalesNotification } from './components/SalesNotification';
export function App() {
  return <div className="relative min-h-screen font-sans text-gray-200 selection:bg-brand-red selection:text-white" data-id="element-0">
      {/* Ambiente argentino de fondo — sutil, no sofoca el contenido */}
      <div className="fixed inset-0 -z-30 bg-brand-dark" aria-hidden="true" data-id="element-1" />
      <img src="https://images.unsplash.com/photo-1544025162-d76694265947?auto=format&fit=crop&w=1920&q=55" alt="" aria-hidden="true" decoding="async" loading="eager" className="fixed inset-0 -z-20 w-full h-full object-cover opacity-[0.14] pointer-events-none select-none" data-id="element-2" />
      {/* Capa de oscurecido + viñeta para mantener la legibilidad y el estilo premium */}
      <div className="fixed inset-0 -z-10 pointer-events-none bg-gradient-to-b from-brand-dark/92 via-brand-dark/80 to-brand-dark/95" aria-hidden="true" data-id="element-3" />
      <div className="fixed inset-0 -z-10 pointer-events-none" aria-hidden="true" style={{
      background: 'radial-gradient(120% 90% at 50% 0%, rgba(232,185,35,0.06) 0%, rgba(22,19,15,0) 55%)'
    }} data-id="element-4" />

      <Hero data-id="element-5" />
      <Testimonials data-id="element-6" />
      <PainPoints data-id="element-7" />
      <UrgencyBanner data-id="element-8" />
      <Audience data-id="element-9" />
      <Product data-id="element-10" />
      <Comparison data-id="element-11" />
      <Pricing data-id="element-12" />
      <Guarantee data-id="element-13" />
      <FAQ data-id="element-14" />
      <Footer data-id="element-15" />
      <StickyCTA data-id="element-16" />
      <SalesNotification data-id="element-17" />
    </div>;
}